import { CLIENT_URL, SERVER_URL } from "./constants";
import { combineUrl } from "./utils";

export enum SceneKey {
  Error = "error",
  Home = "home",
  Login = "login",
  Signup = "signup",
  Intake = "intake",
  Preview = "preview", // Takes template in local storage and renders it dumbly
  Changelog = "changelog",
  // Private
  Dashboard = "dashboard",
}

export enum DashboardSceneKey {
  Websites = "websites",
  Settings = "settings",
}

export const urls: Record<string, (v?: any, w?: any, x?: any) => string> = {
  [SceneKey.Error]: () => "/404",
  [SceneKey.Home]: () => "/",
  [SceneKey.Login]: () => "/login",
  [SceneKey.Signup]: () => "/signup",
  [SceneKey.Intake]: (
    intakeId?: string,
    templateId?: string,
    startingDomain?: string
  ) =>
    combineUrl(`/intake/${intakeId ?? "new"}`, {
      ...(templateId ? { templateId } : {}),
      ...(startingDomain ? { startingDomain } : {}),
    }).url,
  [SceneKey.Preview]: () => "/preview",
  [SceneKey.Changelog]: (slug: string) => `/changelog${slug ? `/${slug}` : ""}`,
  [DashboardSceneKey.Websites]: () => "/dashboard",
  [DashboardSceneKey.Settings]: (checkoutSuccess: boolean = false) =>
    combineUrl("/dashboard", {
      p: "settings",
      ...(checkoutSuccess ? { checkoutSuccess: true } : {}),
    }).url,
};

export function createClientUrl(path?: string): string {
  return `${CLIENT_URL}${path || ""}`;
}

export function createServerUrl(path?: string): string {
  return `${SERVER_URL}${path || ""}`;
}

export const PRIVATE_URLS = [SceneKey.Dashboard];

export const urlsToScenes: Record<string, SceneKey> = {
  [urls.error()]: SceneKey.Error,
  [urls.home()]: SceneKey.Home,
  [urls.login()]: SceneKey.Login,
  [urls.signup()]: SceneKey.Signup,
  [urls.intake(":intakeId")]: SceneKey.Intake,
  [urls.preview()]: SceneKey.Preview,
  [urls.changelog()]: SceneKey.Changelog,
  [urls.changelog(":slug")]: SceneKey.Changelog,
  [urls.websites()]: SceneKey.Dashboard,
  [urls.settings()]: SceneKey.Dashboard,
};
